<template>
  <!-- Color Picker start -->
  <BasePopover :disabled="disabled" placement="bottom-end" class="w-6">
    <template v-slot:button>
      <div
        class="w-6 h-6 border border-gray-400 rounded"
        :style="{ background: value }"
      ></div>

      
    </template>

    <template v-slot:body>
      <div
        class="rounded shadow-lg inline-block text-left mt-2"
        style="right: 0%;"
      >
        <div class="flex mb-0 list-none flex-wrap pt-0 flex-row">
          <div class="">
            <verte
              model="hex"
              v-model="color"
              display="widget"
              :enableAlpha="false"
              :showHistory="true"
              :colorHistory="colorHistory"
            >
            </verte>
          </div>
        </div>
      </div>
    </template>
  </BasePopover>
</template>

<script>
//Verte Color Picker
//https://baianat.github.io/verte/guide/
import Verte from "verte";
import "verte/dist/verte.css";

export default {
  components: {
    Verte,
  },

  data() {
    return {
      visible: false,
    };
  },

  props: ["value", "colorHistory", "disabled"],

  computed: {
    color: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods:{
    showPicker(){

      if (!this.disabled) this.visible = true;

    }
  }
};
</script>

<style></style>
